import {get, post} from './api';
const getClazzes = get('clazz/list'); //自己创建的班级列表
const getClazz = get('clazz/get');
const getClazzMembers = get('clazz/members'); //班级成员，只有班级创建者有权限查看
const saveClazz = post('clazz/save');
const deleteClazz = post('clazz/delete');  //删除班级
const clazzAddCourse = post('clazz/add-course');
const saveClazzCourse = post('clazz/save-clazz-course');
/*
加入班级：
{
    "clazz_id": 33,
    "clazz_code": "750533"
}
 */
const joinClazz = post('clazz/join'); //加入班级

// 退出班级
const quitClazz = post('clazz/disjoin');

// 班级分享作品
const clazzShare = get('project/clazz-shared');

//解散班级
const disbandClazz = post('clazz/dissolve');

// 移除学生
const removeMembers = post('clazz/remove-member');

// 置顶课程
const putTopClazz = post('clazz/top-clazz-course');

// 取消置顶
const cancelTopClazz = post('clazz/save-clazz-course')


export {
    getClazzes,
    getClazz,
    saveClazz,
    deleteClazz,
    clazzAddCourse,
    saveClazzCourse,
    getClazzMembers,
    joinClazz,
    quitClazz,
    clazzShare,
    disbandClazz,
    removeMembers,
    putTopClazz,
    cancelTopClazz
}
